var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login container",attrs:{"id":"login"}},[_c('h1',[_vm._v("Ingresar al sistema")]),_c('div',{staticClass:"row align-items-center justify-content-center d-flex"},[_c('LoginForm')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }